import React from 'react';
import {Route} from 'react-router-dom';
import Async from './async';
import DefaultBusinessLayout from '../../../components/layout/DefaultBusinessLayout';

export default [
  <Route
    key="/business/gcse"
    element={<DefaultBusinessLayout showContactSales={false} />}
  >
    <Route path="business/gcse" element={<Async />} />
  </Route>,
];
